// Entry point for custom scripts

var svgDotDefault = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="12" height="12" fill="#C9C9C9"/></svg>';

var svgDotActive = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="12" height="12" fill="#FF2D55"/></svg>';

function updateDots($slider) {
    $slider.find('.slick-dots li').each(function() {
        var $li = jQuery(this);
        var $btn = $li.find('button');
        if ($li.hasClass('slick-active')) {
            $btn.html(svgDotActive);
        } else {
            $btn.html(svgDotDefault);
        }
    });
}

(function($) {
    'use strict';

    if (window.cmOxygenBuilder) return;

    $(document).ready(function() {
        if ($('.slider-1item').length) {
            $('.slider-1item').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000
            });

            $('.slider-1item').each(function() {
                var $slider = $(this);
                updateDots($slider);

                $slider.on('afterChange', function() {
                    updateDots($slider);
                });
            });
        }
        if ($('.news-box-slider').length){
            $('.news-box-slider').slick({
                infinite: true,
                arrows: false,
                dots: false,
                centerMode: true,
                centerPadding: '220px',
                slidesToShow: 1,
                speed: 600,
                cssEase: 'ease',
                centerPadding:'30px',
            });

            $('.news-box-slider-prev').click(function () {
                $('.news-box-slider').slick('slickPrev');
            });

            $('.news-box-slider-next').click(function () {
                $('.news-box-slider').slick('slickNext');
            });
        }
    });
})(jQuery);





// Grid Relative — Scroll Animation
// ==============================================
(function () {

    'use strict';

    if (window.cmOxygenBuilder || window.cmGridRelativeInitialized) {
        return;
    }
    window.cmGridRelativeInitialized = true;

    function horizontalOrigin(line) {
        if (line.classList.contains('origin-right')) {
            return 'right center';
        }
        return 'left center';
    }

    function verticalOrigin(line) {
        if (line.classList.contains('origin-bottom')) {
            return 'center bottom';
        }
        return 'center top';
    }

    function resetLines(grid) {
        var horizontal = grid.querySelectorAll('.grid-line.h');
        var vertical = grid.querySelectorAll('.grid-line.v');

        horizontal.forEach(function (line) {
            gsap.set(line, {
                opacity: 1,
                scaleX: 0,
                scaleY: 1,
                transformOrigin: horizontalOrigin(line)
            });
        });

        vertical.forEach(function (line) {
            gsap.set(line, {
                opacity: 1,
                scaleX: 1,
                scaleY: 0,
                transformOrigin: verticalOrigin(line)
            });
        });
    }

    function playGrid(grid) {
        var horizontal = grid.querySelectorAll('.grid-line.h');
        var vertical = grid.querySelectorAll('.grid-line.v');

        var tl = gsap.timeline({
            defaults: {
                ease: 'power3.out'
            }
        });

        if (horizontal.length) {
            tl.to(horizontal, {
                scaleX: 1,
                duration: 1.2,
                delay: 0.05,
                stagger: {
                    each: 0.05
                }
            });
        }

        if (vertical.length) {
            tl.to(vertical, {
                scaleY: 1,
                duration: 1.5,
                stagger: {
                    each: 0.1
                }
            }, horizontal.length ? '<0.05' : 0);
        }
    }

    function initGridAnimation() {
        if (typeof gsap === 'undefined') {
            return;
        }

        var grids = document.querySelectorAll('.grid-relative');
        if (!grids.length) return;

        grids.forEach(function (grid) {
            resetLines(grid);
        });

        if (!('IntersectionObserver' in window)) {
            grids.forEach(function (grid) {
                playGrid(grid);
            });
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                playGrid(entry.target);
                observer.unobserve(entry.target);
            });
        }, {
            root: null,
            rootMargin: '0px 0px -10% 0px',
            threshold: 0
        });

        grids.forEach(function (grid) {
            observer.observe(grid);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGridAnimation);
    } else {
        initGridAnimation();
    }

})();

// ==============================================
// Lenis smooth scroll + GSAP ScrollTrigger bridge
// ==============================================
(function () {
    'use strict';

    if (window.cmOxygenBuilder) {
        return;
    }

    if (typeof Lenis === 'undefined') {
        return;
    }

    var lenis = new Lenis({
        duration: 1.2,
        easing: function (t) {
            return Math.min(1, 1.001 - Math.pow(2, -10 * t));
        },
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smoothWheel: true,
        touchMultiplier: 2
    });

    window.cmLenis = lenis;

    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        lenis.on('scroll', ScrollTrigger.update);

        gsap.ticker.add(function (time) {
            lenis.raf(time * 1000);
        });

        gsap.ticker.lagSmoothing(0);
    } else {
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
    }
})();


// Reveal text animation with GSAP
(function () {
    'use strict';

    function initRevealTextAnimation() {

        // Oxygen builder: keep headings as plain, editable text. Splitting
        // them into .char spans would leak into the saved heading HTML when
        // the user double-clicks to edit, and the reveal timeline never
        // plays reliably inside the builder canvas.
        if (document.body && document.body.classList.contains('oxygen-builder-body')) {
            return;
        }

        if (
            typeof gsap === 'undefined' ||
            typeof SplitType === 'undefined'
        ) {
            return;
        }

        // Oxygen re-executes enqueued scripts for every AJAX-rendered element,
        // so this can run more than once: only initialize groups that have
        // not been set up yet, otherwise their timeline gets replaced by an
        // empty one and the split chars stay hidden.
        var newGroups = Array.prototype.filter.call(
            document.querySelectorAll('.reveal-group'),
            function (group) { return !group._revealTimeline; }
        );

        if (!newGroups.length) {
            return;
        }

        newGroups.forEach(function (group) {

            var tl = gsap.timeline({
                paused: true,
                defaults: {
                    ease: "power4.out"
                }
            });

            // Tất cả element được animate trong group, để dọn will-change sau khi xong
            var groupElements = [];

            group.querySelectorAll('.reveal-text').forEach(function (text, index) {

                var heading = text.querySelector('.split-heading');

                if (!heading) return;

                // Tránh split nhiều lần
                if (heading.dataset.splitInit === 'true') return;
                heading.dataset.splitInit = 'true';

                var split = new SplitType(heading, {
                    types: 'words, chars',
                    tagName: 'span'
                });

                if (split.words) {
                    split.words.forEach(function (word) {
                        word.style.display = 'inline-block';
                    });
                }

                // Tối ưu từng ký tự
                split.chars.forEach(function (char) {

                    char.style.display = 'inline-block';
                    char.style.willChange = 'transform, opacity';
                    char.style.whiteSpace = 'nowrap';
                    char.style.lineHeight = 'inherit';
                    char.style.overflow = 'visible';

                });

                // Animation cho SVG icon nếu có
                var svgIcon = heading.querySelector('.split-heading__svg');

                if (svgIcon) {
                    svgIcon.style.willChange = 'transform, opacity';
                }

                // Lấy tất cả elements cần animate theo thứ tự DOM tự nhiên
                var animatableElements = [];

                // Tạo Set để kiểm tra nhanh
                var charSet = new Set(split.chars);
                var includeSvg = svgIcon ? new Set([svgIcon]) : new Set();

                // Query tất cả elements trong heading theo thứ tự DOM
                var allElements = heading.querySelectorAll('*');

                allElements.forEach(function (el) {
                    if (charSet.has(el) || includeSvg.has(el)) {
                        animatableElements.push(el);
                        groupElements.push(el);
                    }
                });

                // Animation theo thứ tự DOM
                // Dùng y (px) tính theo line-height thay vì yPercent: .char có
                // padding bù Safari nên offsetHeight lớn hơn dòng chữ thật,
                // yPercent sẽ làm quãng đường trượt bị dài ra.
                tl.fromTo(
                    animatableElements,
                    {
                        y: function (i, target) {
                            var lh = parseFloat(getComputedStyle(target).lineHeight);
                            return (isNaN(lh) ? target.offsetHeight : lh) * 1.2;
                        },
                        opacity: 0
                    },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.95,
                        stagger: {
                            each: 0.045,
                            from: "start"
                        }
                    },

                    // Heading thứ 2 bắt đầu khi heading trước còn khoảng 35%
                    index === 0 ? 0 : "-=0.20"

                );

            });

            // Animate xong thì bỏ compositing layer (will-change + transform)
            // để Safari vẽ lại text bình thường và đỡ tốn bộ nhớ layer
            tl.eventCallback('onComplete', function () {
                gsap.set(groupElements, { clearProps: 'transform,willChange' });
                groupElements.forEach(function (el) {
                    el.style.willChange = 'auto';
                });
            });

            group._revealTimeline = tl;

        });

        // Play khi scroll tới
        if ('IntersectionObserver' in window) {

            var observer = new IntersectionObserver(function (entries) {

                entries.forEach(function (entry) {

                    if (!entry.isIntersecting) return;

                    if (entry.target._revealTimeline) {
                        entry.target._revealTimeline.play();
                    }

                    observer.unobserve(entry.target);

                });

            }, {
                root: null,
                threshold: 0.15,
                rootMargin: '0px 0px -15% 0px'
            });

            newGroups.forEach(function (group) {
                observer.observe(group);
            });

        } else {

            newGroups.forEach(function (group) {

                if (group._revealTimeline) {
                    group._revealTimeline.play();
                }

            });

        }

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initRevealTextAnimation);
    } else {
        initRevealTextAnimation();
    }

})();

// ==============================================
// Fade Up Animation
// ==============================================
(function() {
    'use strict';

    window.initFadeUpAnimation = initFadeUpAnimation;
    function initFadeUpAnimation() {
        // Check if in Oxygen Builder preview - disable animation
        if (document.body && document.body.classList.contains('oxygen-builder-body')) {
            return;
        }

        var elements = document.querySelectorAll('.fade-up');
        if (!elements.length) return;

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function(entries) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {

                        setTimeout(function() {
                            entry.target.classList.add('show');
                        },  500);

                        observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.01,
                rootMargin: '0px 0px 0px 0px'
            });

            elements.forEach(function(el) {
                observer.observe(el);
            });
        } else {
            // Fallback: show all immediately
            elements.forEach(function(el) {
                el.classList.add('show');
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFadeUpAnimation);
    } else {
        initFadeUpAnimation();
    }
})();

// ==============================================
// Tab Content Switcher (GSAP)
// ==============================================
(function () {
    'use strict';

    function initTabSwitcher() {

        const tabClasses = ['group-1', 'group-2', 'group-3', 'group-4'];
        const allItems = Array.from(document.querySelectorAll('.content-item'));

        if (!allItems.length || typeof gsap === 'undefined') return;

        const parentMap = new Map();
        allItems.forEach(function (item) {
            const parent = item.parentElement;
            if (!parent) return;
            if (!parentMap.has(parent)) parentMap.set(parent, []);
            parentMap.get(parent).push(item);
        });

        parentMap.forEach(function (items, parent) {
            if (items.length < 1) return;

            let stage = parent.querySelector(':scope > .content-item-stage');
            if (!stage) {
                stage = document.createElement('div');
                stage.className = 'content-item-stage';
                parent.insertBefore(stage, items[0]);
                items.forEach(function (item) {
                    stage.appendChild(item);
                });
            }

            let currentContent =
                stage.querySelector('.content-item.active') || items[0];
            let isAnimating = false;

            function measurePanel(el) {
                if (!el) return 0;

                const prevStyles = {
                    position: el.style.position,
                    visibility: el.style.visibility,
                    display: el.style.display,
                    opacity: el.style.opacity,
                    height: el.style.height,
                    maxHeight: el.style.maxHeight,
                    minHeight: el.style.minHeight,
                    overflow: el.style.overflow,
                    transform: el.style.transform,
                    pointerEvents: el.style.pointerEvents
                };

                const prevStageOverflow = stage.style.overflow;
                const prevStageHeight = stage.style.height;

                el.style.position = 'static';
                el.style.visibility = 'hidden';
                el.style.display = 'block';
                el.style.opacity = '1';
                el.style.height = 'auto';
                el.style.maxHeight = 'none';
                el.style.minHeight = '0';
                el.style.overflow = 'visible';
                el.style.transform = 'none';
                el.style.pointerEvents = 'none';

                stage.style.overflow = 'visible';
                stage.style.height = 'auto';

                void el.offsetHeight;
                const h = Math.ceil(
                    Math.max(
                        el.scrollHeight,
                        el.offsetHeight,
                        el.getBoundingClientRect().height
                    ) || 0
                );

                el.style.position = prevStyles.position;
                el.style.visibility = prevStyles.visibility;
                el.style.display = prevStyles.display;
                el.style.opacity = prevStyles.opacity;
                el.style.height = prevStyles.height;
                el.style.maxHeight = prevStyles.maxHeight;
                el.style.minHeight = prevStyles.minHeight;
                el.style.overflow = prevStyles.overflow;
                el.style.transform = prevStyles.transform;
                el.style.pointerEvents = prevStyles.pointerEvents;

                stage.style.overflow = prevStageOverflow;
                stage.style.height = prevStageHeight;

                return h;
            }

            function setStageHeight(h, animate, duration) {
                if (!h) return;
                if (animate) {
                    gsap.to(stage, {
                        height: h,
                        duration: duration || 0.55,
                        ease: 'power2.inOut',
                        overwrite: 'auto'
                    });
                } else {
                    gsap.set(stage, { height: h });
                }
            }

            function stackPanel(el, visible) {
                gsap.set(el, {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    pointerEvents: visible ? 'auto' : 'none',
                    autoAlpha: visible ? 1 : 0,
                    y: visible ? 0 : 10
                });
            }

            gsap.set(parent, {
                clearProps: 'height,overflow'
            });

            gsap.set(stage, {
                position: 'relative',
                overflow: 'hidden',
                width: '100%'
            });

            items.forEach(function (item) {
                const isActive = item === currentContent;
                if (isActive) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
                stackPanel(item, isActive);
            });

            setStageHeight(measurePanel(currentContent), false);

            // Set is-active class on tabs based on active content item
            if (currentContent && currentContent.hasAttribute('data-content-box')) {
                const activeTabName = currentContent.getAttribute('data-content-box');
                if (activeTabName && tabClasses.indexOf(activeTabName) !== -1) {
                    document.querySelectorAll('.' + activeTabName).forEach(function (el) {
                        el.classList.add('is-active');
                    });
                }
            }

            items.forEach(function (item) {
                item.querySelectorAll('img').forEach(function (img) {
                    if (img.complete) return;
                    img.addEventListener('load', function () {
                        if (isAnimating || item !== currentContent) return;
                        setStageHeight(measurePanel(currentContent), true, 0.35);
                    }, { once: true });
                });
            });

            function showContent(name) {
                if (isAnimating) return;

                const nextContent = stage.querySelector(
                    '[data-content-box="' + name + '"]'
                );

                if (!nextContent || nextContent === currentContent) return;

                isAnimating = true;

                tabClasses.forEach(function (cls) {
                    document.querySelectorAll('.' + cls).forEach(function (el) {
                        el.classList.remove('is-active');
                    });
                });

                document.querySelectorAll('.' + name).forEach(function (el) {
                    el.classList.add('is-active');
                });

                const prevContent = currentContent;
                const fromHeight =
                    Math.ceil(stage.getBoundingClientRect().height) ||
                    measurePanel(prevContent);
                const toHeight = measurePanel(nextContent) || fromHeight;

                gsap.set(stage, {
                    height: fromHeight,
                    overflow: 'hidden'
                });

                nextContent.classList.add('active');
                stackPanel(nextContent, false);
                gsap.set(nextContent, {
                    autoAlpha: 0,
                    y: 12
                });

                if (prevContent) {
                    gsap.set(prevContent, { pointerEvents: 'none' });
                }

                const tl = gsap.timeline({
                    defaults: { force3D: true },
                    onComplete: function () {
                        if (prevContent) {
                            prevContent.classList.remove('active');
                            stackPanel(prevContent, false);
                        }

                        stackPanel(nextContent, true);
                        currentContent = nextContent;

                        requestAnimationFrame(function () {
                            const finalH = measurePanel(nextContent) || toHeight;
                            gsap.set(stage, {
                                height: finalH,
                                overflow: 'hidden'
                            });
                            isAnimating = false;
                        });
                    }
                });

                if (Math.abs(fromHeight - toHeight) > 1) {
                    tl.to(stage, {
                        height: toHeight,
                        duration: 0.55,
                        ease: 'power2.inOut'
                    }, 0);
                }

                if (prevContent) {
                    tl.to(prevContent, {
                        autoAlpha: 0,
                        y: -8,
                        duration: 0.4,
                        ease: 'power2.in'
                    }, 0);
                }

                tl.to(nextContent, {
                    autoAlpha: 1,
                    y: 0,
                    duration: 0.5,
                    ease: 'power2.out',
                    onStart: function () {
                        nextContent.style.pointerEvents = 'auto';
                    }
                }, 0.1);
            }

            tabClasses.forEach(function (cls) {
                document.querySelectorAll('.' + cls).forEach(function (el) {
                    el.addEventListener('click', function () {
                        showContent(cls);
                    });
                });
            });

            let resizeTimer;
            window.addEventListener('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    if (isAnimating || !currentContent) return;
                    setStageHeight(measurePanel(currentContent), false);
                }, 100);
            });

            // Check URL parameter for tab on page load
            var urlParams = new URLSearchParams(window.location.search);
            var tabParam = urlParams.get('tab');
            if (tabParam && tabClasses.indexOf(tabParam) !== -1) {
                // Store hash and remove it to prevent native browser scroll
                var hash = window.location.hash.substring(1);
                if (hash) {
                    history.replaceState(null, null, window.location.pathname + window.location.search);
                }

                showContent(tabParam);

                // Scroll to hash fragment after tab activation
                if (hash) {
                    setTimeout(function() {
                        var targetElement = document.getElementById(hash);
                        if (targetElement) {
                            var rect = targetElement.getBoundingClientRect();
                            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                            window.scrollTo({
                                top: scrollTop + rect.top,
                                behavior: 'smooth'
                            });
                            // Restore hash in URL
                            history.replaceState(null, null, '#' + hash);
                        }
                    }, 600); // Wait for tab animation to complete
                }
            }
        });

    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTabSwitcher);
    } else {
        initTabSwitcher();
    }

})();

// ==============================================
// Scroll Scale Image — GSAP Observer
// ==============================================
(function() {
    'use strict';

    function initScrollScaleImage() {
        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
            return;
        }

        var scaleContainers = document.querySelectorAll('.scroll-scale-container');
        if (!scaleContainers.length) return;

        scaleContainers.forEach(function(container) {
            var image = container.querySelector('.scroll-scale-image');
            if (!image) return;

            var triggerEl = container.closest('.reveal-group')
                || container.parentElement
                || container;

            var minScale = 0.8;
            var maxScale = window.innerWidth < 991 ? 1.25 : 1.35;

            gsap.set(image, {
                scale: minScale,
                transformOrigin: 'center center'
            });

            ScrollTrigger.create({
                trigger: triggerEl,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
                onUpdate: function(self) {
                    var progress = self.progress;
                    var scale = minScale + (maxScale - minScale) * progress;
                    gsap.to(image, {
                        scale: scale,
                        duration: 0.1,
                        ease: 'power1.out',
                        overwrite: true
                    });
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initScrollScaleImage);
    } else {
        initScrollScaleImage();
    }
})();
// ==============================================
// Universal Parallax
// ==============================================
(function () {

    'use strict';

    function initUniversalParallax() {

        if (typeof gsap === 'undefined') return;

        var sections = Array.from(
            document.querySelectorAll('.parallax')
        );

        if (!sections.length) return;

        var items = [];

        sections.forEach(function (section) {

            var media =

                section.querySelector('.oxy-video-container') ||

                section.querySelector('.parallax-media') ||

                section.querySelector(':scope > picture') ||

                section.querySelector(':scope > img');

            if (!media) return;

            items.push({

                section: section,

                media: media,

                current: 0,

                target: 0

            });

        });

        if (!items.length) return;

        function update() {

            items.forEach(function (item) {

                var rect =
                    item.section.getBoundingClientRect();

                if (
                    rect.bottom < -200 ||
                    rect.top > window.innerHeight + 200
                ) return;

                var progress =
                    (window.innerHeight - rect.top) /
                    (window.innerHeight + rect.height);

                progress = gsap.utils.clamp(
                    0,
                    1,
                    progress
                );

                item.target = gsap.utils.mapRange(
                    0,
                    1,
                    -30,
                    30,
                    progress
                );

                item.current +=
                    (item.target - item.current) * 0.12;

                item.media.style.transform =
                    'translate3d(0,' +
                    item.current.toFixed(2) +
                    '%,0)';

            });

            requestAnimationFrame(update);

        }

        requestAnimationFrame(update);

    }

    if (document.readyState === 'loading') {

        document.addEventListener(
            'DOMContentLoaded',
            initUniversalParallax
        );

    } else {

        initUniversalParallax();

    }

})();

// ==============================================
// Image Parallax
// Add class "img-parallax" to the <img>'s parent.
// Optional: data-parallax-amount="8" (% of image
// height travelled in each direction).
//
// The <img> is wrapped in a frame that keeps its
// original layout box and clips the overflow, so
// only the picture drifts — the surrounding layout
// never moves.
// ==============================================
(function () {
    'use strict';

    var SELECTOR = '.img-parallax';
    var DEFAULT_AMOUNT = 8;
    var EASE = 0.12;

    var items = [];

    function wrap(host) {
        var img = host.querySelector('img');
        if (!img || img.closest('.img-parallax__frame')) return;

        var amount = parseFloat(host.getAttribute('data-parallax-amount'));
        if (!amount || amount <= 0) amount = DEFAULT_AMOUNT;

        var rect = img.getBoundingClientRect();

        var frame = document.createElement('span');
        frame.className = 'img-parallax__frame';
        // Oversize just past the travel distance so the edges stay covered.
        frame.style.setProperty('--parallax-scale', 1 + (amount * 2 + 1) / 100);

        // The image is cropped (fixed height + object-fit) rather than shown at
        // its natural ratio — pin it to the frame instead of letting it flow.
        var naturalHeight = img.naturalWidth
            ? rect.width * (img.naturalHeight / img.naturalWidth)
            : rect.height;
        if (Math.abs(naturalHeight - rect.height) > 1) {
            frame.classList.add('is-cover');
            frame.style.aspectRatio = rect.width + ' / ' + rect.height;
        }

        img.parentNode.insertBefore(frame, img);
        frame.appendChild(img);

        items.push({
            frame: frame,
            amount: amount,
            current: 0,
            visible: true
        });
    }

    function update() {
        var viewportHeight = window.innerHeight;

        items.forEach(function (item) {
            if (!item.visible) return;

            var rect = item.frame.getBoundingClientRect();

            var progress = (viewportHeight - rect.top) /
                (viewportHeight + rect.height);

            progress = Math.min(1, Math.max(0, progress));

            var target = (progress * 2 - 1) * item.amount;

            item.current += (target - item.current) * EASE;

            item.frame.style.setProperty(
                '--parallax-y',
                item.current.toFixed(3) + '%'
            );
        });

        requestAnimationFrame(update);
    }

    function initImageParallax() {
        Array.prototype.forEach.call(
            document.querySelectorAll(SELECTOR),
            wrap
        );

        if (!items.length) return;

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    items.forEach(function (item) {
                        if (item.frame === entry.target) {
                            item.visible = entry.isIntersecting;
                        }
                    });
                });
            }, { rootMargin: '200px 0px' });

            items.forEach(function (item) {
                observer.observe(item.frame);
            });
        }

        requestAnimationFrame(update);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initImageParallax);
    } else {
        initImageParallax();
    }
})();

// ==============================================
// Grid Auto Rows
// ==============================================
(function () {
    'use strict';

    function updateGridAutoRows() {
        var grids = document.querySelectorAll('.grid');

        grids.forEach(function (grid) {
            var styles = getComputedStyle(grid);

            var columns = styles.gridTemplateColumns
                .split(' ')
                .filter(Boolean).length;

            var gap = parseFloat(styles.columnGap) || 0;

            var cellSize =
                (grid.clientWidth - gap * (columns - 1)) / columns;

            grid.style.gridAutoRows = cellSize + 'px';
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', updateGridAutoRows);
    } else {
        updateGridAutoRows();
    }

    window.addEventListener('resize', updateGridAutoRows);

})();
